module.exports = {"loading":"加载中...","Reset":"重置","Search":"搜索","Confirm Cancel ?":"要取消吗？","Confirm ?":"确定继续？","Table display settings":"表格显示设置","Check / uncheck to change visibility, drag to change order:":"只有选中的字段可见，拖拽来排列显示顺序：","Edit":"编辑","Detail":"详情","Delete":"删除","Confirm":"确认","Cancel":"取消","Select / Unselect All":"全选 / 取消全选"}


//////////////////
// WEBPACK FOOTER
// ./packages/lang/test-zh-Hans.json
// module id = 313
// module chunks = 0